<template>
	<div>
		<DialogEditarUsuario
			@loadUsuarios="loadUsuarios"
			:id="id"
			:abrirDialog="cadastrar"
			@dialogClose="dialogClose"
		/>
		<v-row align="center" justify="center">
			<v-col md="11" xl="8">
				<CardPersonalizado titulo="Usuários" icone="mdi-account-outline">
					<div class="cabeçalho">
						<v-row>
							<v-col cols="12" md="9" class="pa-1">
								<v-text-field
									v-model="search"
									solo
									placeholder="Procure um usuário"
									elevation="9"
									background-color="#FAFAFA"
									hide-details
								></v-text-field>
							</v-col>
							<v-col cols="12" md="3" class="pa-1">
								<v-btn
									v-if="userAdmin"
									class="white--text"
									color="#CC2128"
									elevation="9"
									width="100%"
									@click="editarUsuario()"
									large
								>
									<v-icon left> mdi-plus </v-icon>
									Cadastrar Usuário
								</v-btn>
							</v-col>
						</v-row>
					</div>

					<TabelaPersonalizada :headers="headers" :itens="usuarios" :loading="loading" @setOptions="setOptions" @editar="editarUsuario">
						<template v-slot:[`item.admin`]="{ item }">
							<v-icon small class="mr-2">
								{{ retornarIcone(item.admin) }}
							</v-icon>
						</template>
						<template v-slot:[`item.ativo`]="{ item }">
							<v-icon small class="mr-2">
								{{ retornarIcone(item.ativo) }}
							</v-icon>
						</template>
					</TabelaPersonalizada>
				</CardPersonalizado>
			</v-col>
		</v-row>
	</div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import DialogEditarUsuario from '../components/usuarios/DialogEditarUsuario'
import CardPersonalizado from '../components/shared/cardPersonalizado.vue'
import TabelaPersonalizada from '../components/shared/tabelaPersonalizada.vue'

export default {
	components: { DialogEditarUsuario, CardPersonalizado, TabelaPersonalizada },
	data: function () {
		return {
			search: '',
			id: '',
			usuarios: [],
			options: {},
			cadastrar: false,
			editar: false,
			headers: [
				{ text: 'Nome', value: 'nome', sortable: false },
				{ text: 'E-mail', value: 'email', sortable: false },
				{ text: 'Cidade', value: 'cidade', sortable: false },
				{ text: 'Admin', value: 'admin', sortable: false },
				{ text: 'Ativo', value: 'ativo', sortable: false },
			],
			loading: false,
		}
	},
	methods: {
		...mapMutations('usuarios', ['setUsuario']),
		...mapActions('usuarios', ['showDialog']),
		async loadUsuarios() {
			try {
				this.loading = true

				const { page, itemsPerPage } = this.options
				const response = await this.axios.get('/usuarios', {
					params: { 
						search: this.search,
						limit: itemsPerPage,
						page 
					},
				})
				this.usuarios = response.data.usuarios
				this.total = response.data.total
			} catch (error) {
				this.$store.dispatch('showError', error)
			} finally {
				this.loading = false
			}
		},
		setOptions(options) {
			this.options = options
			this.loadUsuarios()
		},
		cadastrarFornecedor() {
			this.cadastrar = true
		},
		editarUsuario(id) {
			this.id = id
			this.cadastrar = true
		},
		dialogClose() {
			this.cadastrar = false
		},
	},
	mounted() {
		this.loadUsuarios()
	},
	watch: {
		search() {
			this.loadUsuarios()
		},
	},
	computed: {
		...mapGetters(['userAdmin', 'userMaster']),
	},
}
</script>

<style scoped>
.cabeçalho {
	padding: 8px 8px 0 8px;
	margin-bottom: 20px;
}
.col {
	padding: 4px;
}
</style>

